/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
// eslint-disable-next-line import/no-extraneous-dependencies
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { client } from "./api-client";

export const useGetAllRoutes = (data: any) =>
  useQuery<{
    data: any[];
    totalPages: number;
    totalRecords: number;
  }>({
    queryKey: [
      "GetAllRoutes",
      data?.pageNumber,
      data?.pageRowCount,
      data?.searchCriteria,
      data?.cashCenterId,
      data?.region,
    ],
    queryFn: ({ signal }) =>
      client(`daily/operations/routes`, { data, signal }),
  });

export const useGetRosterTemplate = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(
        `daily/operations/rosters/generate/template/${data.cashCenterId}/${data.region}`,
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["GetRosterEditTemplate"] });
    },
  });
};

export const useUpdateRoutesTeam = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(`daily/operations/update/field/team`, {
        data,
        successMessage: "Routes teams updated successfully!",
      }),
    ...{
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ["GetAllRoutes"] });
      },
    },
  });
};

export const useGenerateBulkRoaster = () =>
  useMutation({
    mutationFn: (data: any) =>
      client(`daily/operations/create/roster/bulk`, {
        data,
        successMessage: "Bulk Roster created successfully!",
      }),
  });

export const useGenerateRoster = () =>
  useMutation({
    mutationFn: (data: any) =>
      client(`daily/operations/create/roster`, {
        data,
        successMessage: "Roster created successfully!",
      }),
  });

export const useAddRoute = () =>
  useMutation({
    mutationFn: (data: any) => client(`daily/operations/add/routes`, { data }),
  });

export const useDeleteRoute = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(`daily/operations/delete/roster`, {
        data,
        successMessage: "Selected routes deleted successfully!",
      }),
    ...{
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ["GetAllRoutes"] });
      },
    },
  });
};

export const useAddNewRoute = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(`resources/routes/add`, {
        data,
        successMessage: "Route added successfully!",
      }),
    ...{
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ["GetAllRoutes"] });
      },
    },
  });
};

export const useEditRoute = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(`resources/routes/edit`, {
        data,
        successMessage: "Route updated successfully!",
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["GetAllRoutes"] });
    },
  });
};
export const useGetRouteEditTemplate = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(`daily/operations/routes/edit/template`, {
        data,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["GetRouteEditTemplate"] });
    },
  });
};
export const useEditRoutesInBulk = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(`daily/operations/routes/edit/bulk`, {
        data,
        successMessage: "Route updated successfully in bulk!",
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["EditRoutesInBulk "] });
    },
  });
};

export const useSwapRouteTeam = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(`daily/operations/routes/swap/team/members`, {
        data,
        successMessage: "Team swapped successfully!",
      }),
    ...{
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ["swapRouteTeam"] });
      },
    },
  });
};

export const useExportRoutes = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(`daily/operations/routes/export`, {
        data,
      }),
    ...{
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ["exportRoutes"] });
      },
    },
  });
};

export const useEditDailyOperationRoutes = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(`daily/operations/routes/edit`, {
        data,
        successMessage: "Route updated successfully!",
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["EditDailyOperationRoute"] });
    },
  });
};
